export default {
  id: "fgf",
  name: "FGF-Geostrategy",
  companyName: "Fordham Global Foresight",
  legalName: "Fordham Global Foresight Group Ltd.",
  allowedDomains: ["fordhamglobal.com", "fgf-geostrategy.com"],
  subtitle: "Insights",
  logo: "/logo.svg",
  favicon: "/favicon.svg",
  pageTitle: "FGF-Geostrategy Insights",
  fromEmail: "insights@fordhamglobal.com",
  replyToEmail: "hello@fordhamglobal.com",
  contactEmail: "info@fordhamglobal.com",
  address:
    "Fordham Global Foresight, 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom",
  socialLinks: {
    linkedin: "https://www.linkedin.com/company/fordham-global-foresight",
    youtube: "https://www.youtube.com/@TinaFordhamuk",
    x: "https://x.com/TinaFordham1",
    instagram: "https://www.instagram.com/fordham.tina/",
    web: "https://fordhamglobal.com/",
  },
  currency: { code: "GBP", symbol: "£", locale: "en-GB" },
  features: {
    ghl: true,
    stripe: true,
    sendgrid: true,
    zoom: true,
    o365: true,
  },
  contentBlocks: [
    // Home
    { id: "fgf-hero", label: "Hero Section", page: "Home" },
    { id: "fgf-announcement", label: "Announcement Bar", page: "Home" },
    { id: "fgf-pitch", label: "Boards That Are Going Places", page: "Home" },
    { id: "fgf-insights-grid", label: "Latest Insights Grid", page: "Home" },
    // About
    { id: "fgf-about-intro", label: "About Introduction", page: "About" },
    { id: "fgf-team", label: "Team Profiles", page: "About" },
    // Services
    { id: "fgf-services", label: "Services Overview", page: "Services" },
    // Insights & Influence
    { id: "fgf-insights", label: "Insights & Influence", page: "Insights" },
    { id: "fgf-video-gallery", label: "Video Gallery", page: "Insights" },
    // Newsletter
    { id: "fgf-newsletter", label: "Newsletter Signup", page: "Newsletter" },
  ],
  newsletter: {
    headerBg: "#07062A",
    headerText: "#E7E6E6",
    headerLogoUrl: "/email-logos/fgf-logo-email.png",
    footerBg: "#07062A",
    footerText: "#8AB0C0",
    footerLink: "#E7E6E6",
    dividerColor: "#213D61",
    buttonBg: "#4E95D9",
    buttonText: "#ffffff",
    buttonLabel: "Chairman's Access",
    buttonMergeTag: "{{chairmans_access_link}}",
    accentColor: "#4E95D9",
  },
  theme: {
    sidebar: {
      bg: "#000f2d",
      bgHover: "#0a1a3d",
      bgActive: "#122148",
      border: "#1a2744",
      text: "#ffffff",
      textSecondary: "#c7c7cb",
      accent: "#c7c7cb",
      accentDim: "rgba(199,199,203,0.12)",
    },
    fonts: {
      heading: "'Playfair Display', Georgia, serif",
      body: "'DM Sans', -apple-system, sans-serif",
    },
  },
};
